// actions
import { COMPANY_SLICE_NAME } from '../actions/company.action';

// thunks
import {
  getCompanyDetail,
  getCompanyList,
  getCompanyNames,
  updateCompany
} from '../thunks/company.thunk';

// models
import { CompanyState } from '../models/company.model';

// libraries
import { createSlice } from '@reduxjs/toolkit';
import { getCompanyDetailV2, getCompanyListV2 } from '../thunks/company.thunkV2';

// initialState
const initialState: CompanyState = {
  company: [],
  companyOptions: [],
  companyAllOptions: [],
  totalMap: undefined,
  companyInfo: undefined
};

// createSlice
const companySlice = createSlice({
  name: COMPANY_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyList.fulfilled, (state, action) => {
        const res = action.payload;
        state.company = res.resultList || [];
        state.totalMap = res.totalMap;
      })
      .addCase(getCompanyNames.fulfilled, (state, action) => {
        const companyOptions = action.payload.resultList;

        state.companyOptions = companyOptions;
        state.companyAllOptions = [{ label: 'ALL', value: 'ALL' }, ...companyOptions];
      })
      .addCase(getCompanyDetail.fulfilled, (state, action) => {
        const res = action.payload;
        state.companyInfo = res.resultObject;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        const res = action.payload;
        state.companyInfo = res.resultObject;
      })
      .addCase(getCompanyListV2.fulfilled, (state, action) => {
        const { resultList, totalMap } = action.payload;

        state.company = resultList || [];
        state.totalMap = totalMap;
      })
      .addCase(getCompanyDetailV2.fulfilled, (state, action) => {
        const { resultObject } = action.payload;

        state.companyInfo = resultObject;
      });
  }
});

export const company = companySlice.name;
export const companyReducer = companySlice.reducer;
export const companyActions = companySlice.actions;
export default companySlice.reducer;
